/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconTheme8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTheme8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="m5.76 7.1-.55.27-.595-1.093.688-.338.458 1.16ZM3.449 6.275 2.85 7.366l-.548-.272.461-1.159.686.34Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.426 2.473c0 1.208.956 2.187 2.133 2.187.08 0 .16-.007.237-.015-.044.16-.11.31-.19.45h.002l-.022.035-.009.015a1.814 1.814 0 0 1-1.542.874c-1.009 0-1.827-.84-1.827-1.875 0-.56.24-1.062.621-1.405l.01-.01c.072-.063.148-.121.229-.173v.002a1.8 1.8 0 0 1 .36-.18 2.378 2.378 0 0 0-.002.095ZM3 3.486a1.265 1.265 0 0 0-.183.658c0 .69.546 1.25 1.218 1.25.266 0 .51-.09.71-.237A2.777 2.777 0 0 1 3 3.487Z"
                fill="currentColor"
            />
            <path
                d="m7.37 4.604-.137.609-1.205-.205.172-.761 1.17.357ZM2.04 5.001l-1.205.201-.135-.61 1.172-.352L2.04 5ZM4.037 2.262c1.01 0 1.828.839 1.828 1.874v.026a1.631 1.631 0 0 1-.61 0l.001-.026c0-.69-.546-1.25-1.219-1.25-.035 0-.07.002-.104.005a1.762 1.762 0 0 1-.038-.623c.047-.004.094-.006.142-.006ZM6.854 2.244l-.908.837-.473-.611 1.002-.715.379.49ZM2.607 2.467l-.474.61-.905-.84.38-.49 1 .72ZM4.417 1.95h-.762L3.732.7h.61l.075 1.25Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTheme12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTheme12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m8.838 10.907-.902.433-.978-1.75 1.128-.54.752 1.857ZM5.043 9.587l-.983 1.747-.9-.435.757-1.857 1.126.545Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.006 3.5c0 1.933 1.568 3.5 3.502 3.5.13 0 .26-.01.388-.024a2.958 2.958 0 0 1-.312.722h.004c-.011.02-.025.037-.036.055l-.015.024a2.994 2.994 0 0 1-2.531 1.4c-1.657-.001-3-1.345-3.001-3.002 0-.897.395-1.701 1.02-2.25l.017-.015a3.02 3.02 0 0 1 .375-.279v.003c.185-.115.382-.214.592-.288-.002.051-.003.103-.003.154Zm-.7 1.622a2.002 2.002 0 0 0 1.7 3.054 1.98 1.98 0 0 0 1.164-.38 4.512 4.512 0 0 1-2.863-2.674Z"
                fill="currentColor"
            />
            <path
                d="m11.48 6.912-.224.974-1.979-.328.282-1.219 1.921.573ZM2.73 7.547.752 7.87.53 6.893l1.924-.565.276 1.22ZM6.009 3.16c1.657 0 3 1.344 3 3.002v.04a2.744 2.744 0 0 1-1.001.003l.002-.043a2.001 2.001 0 0 0-2.172-1.993 2.756 2.756 0 0 1-.064-.998c.078-.006.156-.01.235-.01ZM10.633 3.133l-1.49 1.34-.778-.98 1.646-1.144.622.784ZM3.661 3.489l-.78.976L1.397 3.12l.624-.782 1.641 1.15ZM6.633 2.66H5.382l.125-2h1l.126 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTheme16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTheme16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m11.77 14.534-1.203.576-1.302-2.332 1.503-.72 1.002 2.476ZM6.714 12.774l-1.312 2.328-1.199-.58 1.01-2.473 1.5.725Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.662 4.662a4.666 4.666 0 0 0 4.666 4.665c.176 0 .35-.014.52-.033a3.97 3.97 0 0 1-.412.963h.004l-.04.06-.04.065c-.022.035-.045.071-.069.106l-.06.083a3.99 3.99 0 0 1-3.236 1.655 3.999 3.999 0 0 1-2.639-7v-.002c.38-.334.824-.597 1.311-.768a4.823 4.823 0 0 0-.005.206Zm-.93 2.161a2.649 2.649 0 0 0-.403 1.404 2.667 2.667 0 0 0 2.666 2.666c.581 0 1.117-.188 1.554-.505a6.01 6.01 0 0 1-3.817-3.565Z"
                fill="currentColor"
            />
            <path
                d="m15.29 9.21-.299 1.299-2.636-.438.375-1.623 2.56.762ZM3.632 10.056l-2.637.43-.295-1.3 2.563-.754.369 1.624ZM8 4.212a4 4 0 0 1 3.999 3.999l-.002.054a3.656 3.656 0 0 1-1.333.002l.002-.056a2.666 2.666 0 0 0-2.894-2.655 3.675 3.675 0 0 1-.085-1.331c.104-.008.208-.013.313-.013ZM14.16 4.175 12.175 5.96 11.14 4.656l2.193-1.525.827 1.044ZM4.872 4.65 3.833 5.95l-1.98-1.794.833-1.042L4.872 4.65ZM8.831 3.546H7.165L7.331.88h1.333l.167 2.666Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTheme20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTheme20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m14.638 18.17-1.503.72-1.628-2.916 1.88-.9 1.251 3.095ZM8.318 15.97l-1.639 2.91-1.5-.725 1.263-3.092 1.876.907Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.253 5.83a5.834 5.834 0 0 0 5.833 5.832c.22 0 .438-.017.652-.042-.118.427-.294.83-.514 1.203h.002c-.005.01-.012.018-.017.027a5.16 5.16 0 0 1-.318.472l-.003-.001a4.987 4.987 0 0 1-3.969 1.966 5 5 0 0 1-4.999-5c0-1.496.66-2.837 1.701-3.752v-.002l.106-.09.055-.046c.147-.119.302-.229.461-.33l.032-.02c.307-.193.637-.353.984-.475a5.944 5.944 0 0 0-.006.257ZM7.088 8.527A3.335 3.335 0 0 0 9.92 13.62c.728 0 1.4-.236 1.949-.631a7.513 7.513 0 0 1-4.78-4.462Z"
                fill="currentColor"
            />
            <path
                d="m19.04 11.513-.374 1.624-3.295-.547.468-2.03 3.2.953ZM4.465 12.573l-3.296.535-.37-1.625 3.205-.942.461 2.032ZM9.926 5.266a5 5 0 0 1 5 4.999c0 .023-.002.046-.003.068a4.57 4.57 0 0 1-1.667.002c0-.023.003-.046.003-.07a3.333 3.333 0 0 0-3.618-3.32 4.59 4.59 0 0 1-.105-1.663c.128-.01.259-.016.39-.016ZM17.628 5.22l-2.483 2.233-1.294-1.632 2.741-1.908 1.036 1.306ZM6.016 5.812 4.717 7.44 2.242 5.198l1.04-1.303 2.734 1.917ZM10.965 4.433H8.882L9.09 1.1h1.666l.21 3.333Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTheme24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTheme24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m17.657 21.806-1.804.864-1.954-3.5 2.255-1.08 1.503 3.716ZM10.072 19.165l-1.966 3.492-1.8-.87 1.515-3.71 2.25 1.088Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.994 6.995a7 7 0 0 0 7.781 6.954c-.1.363-.235.71-.398 1.042 0 .004-.003.006-.004.009-.05.1-.103.2-.158.297-.025.044-.052.087-.078.13a6.028 6.028 0 0 1-.132.211c-.022.034-.044.068-.067.1a6.049 6.049 0 0 1-.18.25l-.001-.001a5.984 5.984 0 0 1-4.763 2.357A6 6 0 0 1 8.034 7.84v-.002c.101-.088.206-.173.312-.255l.05-.038a6 6 0 0 1 .617-.406l.007-.004c.31-.178.639-.33.981-.45a7.11 7.11 0 0 0-.007.31Zm-1.398 3.238a4 4 0 0 0 3.398 6.11c.873.001 1.677-.28 2.334-.755a9.016 9.016 0 0 1-5.732-5.355Z"
                fill="currentColor"
            />
            <path
                d="m22.94 13.817-.45 1.95-3.954-.657.562-2.436 3.842 1.143ZM5.449 15.088l-3.956.643-.443-1.95 3.844-1.13.555 2.438ZM12.002 6.32a6 6 0 0 1 6 6l-.003.081a5.49 5.49 0 0 1-2 .002l.003-.084a4 4 0 0 0-4.344-3.985 5.51 5.51 0 0 1-.126-1.995c.155-.012.312-.02.47-.02ZM21.244 6.264l-2.98 2.68-1.552-1.958 3.29-2.29 1.242 1.568ZM7.31 6.975 5.75 8.928l-2.97-2.69 1.248-1.564 3.282 2.3ZM13.25 5.32h-2.5l.25-4h2l.25 4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconTheme = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTheme(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconTheme8 {...iconProps} />;
        case '12':
            return <IconTheme12 {...iconProps} />;
        case '16':
            return <IconTheme16 {...iconProps} />;
        case '20':
            return <IconTheme20 {...iconProps} />;
        case '24':
            return <IconTheme24 {...iconProps} />;
        default:
            return <IconTheme24 {...iconProps} />;
    }
});
